import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { min, take } from 'ramda';

import Card from '../../../../components/Card';
import EngagmentMeter from '../../../../components/EngagementMeter';

const propTypes = {
  user: PropTypes.object,
};

function shuffle(a) {
  for (let i = a.length; i; i -= 1) {
    const j = Math.floor(Math.random() * i);
    [a[i - 1], a[j]] = [a[j], a[i - 1]];
  }

  return a;
}

class EngagementCard extends Component {
  state = {
    suggestions: [
      'How many times you have attended Symposium',
      'How many certifications you hold',
      'How long you have held your certifications in good standing',
      'If you are currently a member',
      'How many trainings you have completed',
      'How many webinars you have registered for',
      'If you have agreed to be a media resource for Sage Financial Solutions',
      'If you have agreed to be a mentor',
      'If you have completely filled out your profile',
      'How much you have donated to Sage Financial Solutions',
    ],
  };

  componentDidMount() {
    this.setState({ suggestions: shuffle(this.state.suggestions) });
  }

  render() {
    const { user } = this.props;
    const { suggestions } = this.state;
    const score = min(user.engagementScore, 100);

    return (
      <Card className="mb-4">
        <Card.Header>
          <div>
            My Sage Financial Solutions
            <sup>®</sup>
            Engagement Score
          </div>
        </Card.Header>
        <Card.Body>
          <EngagmentMeter percent={score} />
          <div className="text-center">
            <h1 className="yellow-heading">{score} Points</h1>
          </div>
          <hr />
          <h4 className="bold-blue-heading">Improve your score</h4>
          <p>Your engagement score depends on many factors, such as:</p>
          <ul className="pl-3">
            {take(3, suggestions).map((suggestion, i) => (
              <li key={i}>{suggestion}</li>
            ))}
          </ul>
        </Card.Body>
      </Card>
    );
  }
}

EngagementCard.propTypes = propTypes;

export default EngagementCard;
